import { cn } from '@app/shared/utils/common';

interface EmojiGridProps {
  emojis: string[];
}

export const EmojiGrid = ({ emojis }: EmojiGridProps) => (
  <div className="relative h-full w-full overflow-hidden">
    <ul className="grid h-[calc(100%+30px)] w-[calc(100%+28px)] grid-cols-4 grid-rows-4 items-center gap-[7px]">
      {emojis.map((item, i) => {
        const col = i % 4;
        const row = Math.floor(i / 4);
        const isOverflowed = col === 3 || row === 3;

        return (
          <li
            key={item + i}
            className={cn(
              isOverflowed ? 'bg-white/40' : 'bg-white',
              'flex h-[35px] w-[35px] items-center justify-center rounded-lg text-xl/[30px] sm:h-[42px] sm:w-[42px] md:w-[50px] md:text-2xl/[35px]'
            )}
          >
            {item}
          </li>
        );
      })}
    </ul>
  </div>
);
